import {action, Action} from 'easy-peasy';

interface ActiveDummyStoryboardState {
    activeDummyStoryboardSlug: string;
    setActiveDummyStoryboard: Action<ActiveDummyStoryboardState, string>;
}

const activeDummyStoryboard: ActiveDummyStoryboardState = {
    activeDummyStoryboardSlug: '',
    setActiveDummyStoryboard: action((state, storyboardSlug) => {
        state.activeDummyStoryboardSlug = storyboardSlug;
    }),
};

export default activeDummyStoryboard; 